import React, { memo, useEffect } from 'react'

import { useBoolean } from '@guidde-co/shared.hooks.use-boolean'

import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'

import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import PauseIcon from '@material-ui/icons/Pause'

export type PlayProps = {
    /**
     * HTML video element
     */
    videoElement: HTMLVideoElement | null
}

export const Play = memo(({ videoElement }: PlayProps) => {
    const stopped = useBoolean(videoElement ? videoElement.paused : true)

    const play = () => {
        if (!videoElement) return
        videoElement.play()
    }

    const pause = () => {
        if (!videoElement) return
        videoElement.pause()
    }

    useEffect(() => {
        if (!videoElement) return

        videoElement.addEventListener('playing', stopped.setFalse)
        videoElement.addEventListener('pause', stopped.setTrue)

        return () => {
            videoElement.removeEventListener('playing', stopped.setFalse)
            videoElement.removeEventListener('pause', stopped.setTrue)
        }
    }, [videoElement, stopped.setTrue, stopped.setFalse])

    return (
        <Box
            mr={1.5}
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            {stopped.isTrue ? (
                <>
                    <IconButton
                        onClick={play}
                        size="small"
                        disableRipple={true}
                        style={{ color: 'white' }}
                    >
                        <PlayArrowIcon fontSize="small" />
                    </IconButton>
                </>
            ) : (
                <IconButton
                    onClick={pause}
                    size="small"
                    disableRipple={true}
                    style={{ color: 'white' }}
                >
                    <PauseIcon fontSize="small" />
                </IconButton>
            )}
        </Box>
    )
})
